/**
 * @desc 编辑并且重试中转执行
 */
const URL = "/rantion-bus";
import http, { updateResponse } from "@/http";
export function request(recordId: string | number, body: ObjectMap<any, object>, options?: any) {
  return updateResponse(
    http(URL + `/exchange/editAndReExecute/${recordId}`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
